import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const pageSelector = createSelector(selfSelector, (rejectsReport) => rejectsReport.page);

export default pageSelector;
